// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import ChoicesController from './choices_controller'
application.register('choices', ChoicesController)

import TurboSubmitController from './turbo_submit_controller'
application.register('turbo-submit', TurboSubmitController)

import ShowhideController from './showhide_controller'
application.register('showhide', ShowhideController)
